/**
 * Created by mykurisu on 2017/8/21.
 */
import React from 'react'
import {Link} from 'react-router'
import {renderMoney} from '../../utils'
import WalletTopIcon from '../../images/wallet/wallet-top-icon.png'


class WalletNewHeader extends React.Component {

    render() {
        const {moneyInfo} = this.props;

        return (
            <div className="wallet-new-page-header">
                <div className="header-image-area" style={{backgroundImage: `url(${WalletTopIcon})`}}>
                    <div className="image-area">
                        <p className="area-title">我的余额（元）</p>
                        <Link to={'/wallet/transaction'}>
                            <p className="area-price">{renderMoney(moneyInfo.balance)}</p>
                            <p className="area-more">查看明细</p>
                        </Link>
                    </div>
                </div>
            </div>
        )
    }
}

export default WalletNewHeader



// WEBPACK FOOTER //
// ./src/components/wallet/WalletNewHeader.js